import $ from 'jquery';

$(function() {

  // Toggle login/register forms
  $('.js-show-register, .js-show-login').on('click', () => {
    $('.js-login-form').fadeToggle();
    $('.js-register-form').fadeToggle();
  });

  // Show dash nav 'my account' menu
  $('.dash-nav__account').on('click', () => {
    $('.dash-nav__account-menu').toggleClass('active');
  });

  if ($('.woocommerce-notices-wrapper').children().length > 0) {
    $('.woocommerce-notices-wrapper').addClass('active');
  }

  // Toggle display of payment methods
  if ($('body').hasClass('woocommerce-checkout')) {
    $(document).on('change', '.wc_payment_method input[name="payment_method"]', function(event) {

      const paymentId = $(this).attr('id');
      const $clickedMethod = $(`.wc-payment-info[data-payment-id="${paymentId}"]`);

      $(`.wc-payment-info:not([data-payment-id="${paymentId}"])`).slideUp(300, function () {
        $clickedMethod.slideDown()
      });

    });
  }

  // Notification event handlers

  // Open notifications
  $('.notifs__btn').on('click', function() {
    $('.notifs__popup').toggleClass('active');
  });

  // Close notifications
  $('.notifs__close').on('click', function() {
    $('.notifs__popup').removeClass('active');
  });

});